import { ADD_CALLABLE_ASSOCIATION } from 'calling-global-api/constants/EventListeners';
export function triggerHostMessageAddCallableAssociation(data) {
  if (window.hsCalling.triggerEvent) {
    window.hsCalling.triggerEvent({
      event: ADD_CALLABLE_ASSOCIATION,
      data
    });
  }
}